import React from "react";
import PropTypes from "prop-types";

import Dialog from ".";

const ConfirmDialog = ({
  cancelLabel,
  children,
  confirmLabel,
  info,
  onCancel,
  onConfirm,
  title,
}) => (
  <Dialog
    cancelLabel={cancelLabel}
    confirmLabel={confirmLabel}
    info={info}
    onCancel={onCancel}
    onConfirm={onConfirm}
    title={title}
    isCancelable
    isOpen
  >
    {children}
  </Dialog>
);

ConfirmDialog.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  cancelLabel: PropTypes.string,
  confirmLabel: PropTypes.string,
  info: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  title: PropTypes.string,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

export default ConfirmDialog;
